import React from "react";
import { Modal, ModalBody } from 'reactstrap';
import { ReactSession } from "react-client-session";

import { Helpers } from "../config/Helpers";

class ModalCabang extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            isModalOpen: false,
            loading: true,
            branchData: [],
            search: '',
            branchCode: (ReactSession.get("branch_code")) ? ReactSession.get("branch_code") : '',
        };
    }

    open = () => {
        this.setState({ isModalOpen: true, loading: true, search: '' }, () => {
            this.getCabang();
        });
    };

    handleModal = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };

    getCabang = () => {
        Helpers.getCabang('', '', '').then(res => {
            this.setState({ branchData: (res) ? res : [], loading: false });
        });
    };

    handleSelect = (object) => {
        ReactSession.set("branch_code", object.KodeCabang);
        ReactSession.set("branch_name", object.NamaCabang);
        ReactSession.set("sess_order_pinpoint", '');
        ReactSession.set("sess_order_jarak", '0');
        ReactSession.set("sess_order_jasakirim", '0');

        window.location.reload();
    };

    render() {
        const filtered = this.state.branchData.filter((object) => {
            if (!this.state.search) return true;
            return (object.NamaCabang || '').toUpperCase().indexOf(this.state.search.toUpperCase()) !== -1;
        });

        return (
            <Modal
                size={'md'}
                isOpen={this.state.isModalOpen}
                toggle={() => { this.handleModal() }}
                contentClassName="modal-picker-content">
                <ModalBody className="modal-picker-body">
                    <div className="modal-picker-header">
                        <div className="modal-picker-title">
                            <span className="modal-picker-icon"><i className="fi-rs-marker"></i></span>
                            Pilih Cabang Waroq
                        </div>
                        <button type="button" className="modal-picker-close" onClick={() => { this.handleModal() }} aria-label="Tutup">
                            <i className="fi-rs-cross"></i>
                        </button>
                    </div>

                    <div className="modal-picker-search">
                        <i className="fi-rs-search"></i>
                        <input
                            type="text"
                            placeholder="Cari cabang ..."
                            value={this.state.search}
                            onChange={(e) => this.setState({ search: e.target.value })}
                        />
                    </div>

                    <div className="modal-picker-list">
                        {
                            this.state.loading ? (
                                <div className="modal-picker-empty">
                                    <div className="modal-picker-spinner"></div>
                                    <p>Memuat data cabang...</p>
                                </div>
                            ) : filtered.length > 0 ? (
                                filtered.map((object, i) => {
                                    const active = object.KodeCabang === this.state.branchCode;
                                    return (
                                        <div
                                            key={i}
                                            className={'modal-picker-item' + (active ? ' active' : '')}
                                            onClick={() => { this.handleSelect(object) }}
                                        >
                                            <span className="modal-picker-item-icon">
                                                <i className="fi-rs-marker"></i>
                                            </span>
                                            <span className="modal-picker-item-text">{object.NamaCabang}</span>
                                            {
                                                active && (
                                                    <span className="modal-picker-item-check"><i className="fi-rs-check"></i></span>
                                                )
                                            }
                                        </div>
                                    );
                                })
                            ) : (
                                <div className="modal-picker-empty">
                                    <i className="fi-rs-marker" style={{ fontSize: '30px', color: '#ddd' }}></i>
                                    <p>Cabang tidak ditemukan</p>
                                </div>
                            )
                        }
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}

export default ModalCabang;
